import React from 'react';
import styled from 'styled-components';

import { Calling as CallingIcon } from '@icons/dialer/calls';
import { ValueOf } from '@utils/tsUtils';
import { INCOMING_SOUND, OUTGOING_SOUND } from '../../../constants/sounds';
import AudioPlayer from '../../AudioPlayer';

const Type = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
};

const { Status: AudioStatus } = AudioPlayer;

export interface CallingStateProps {
  className?: string;
  isInterception: boolean;
  contact: { fullName?: string; number?: string } | null;
  type: ValueOf<typeof Type>;
  isMasterInstance?: boolean;
  volume: number;
  onSubmit: () => void;
}

interface CallingStateState {
  isClicked: boolean;
}

class CallingState extends React.PureComponent<
  CallingStateProps,
  CallingStateState
> {
  static defaultProps = {
    className: '',
    contact: null,
    isInterception: false,
    type: Type.INCOMING,
  };

  constructor(props) {
    super(props);

    this.state = {
      isClicked: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { onSubmit } = this.props;

    onSubmit();
    this.setState({
      isClicked: true,
    });
  }

  render() {
    const { className, contact, type, isInterception, volume } = this.props;

    const fullName = contact?.fullName;
    const number = contact?.number;

    const { isClicked } = this.state;
    const isIncoming = type === Type.INCOMING;
    let acceptTitle = '';
    if (isClicked) {
      acceptTitle = isIncoming ? 'Соединение...' : 'Отмена...';
    } else {
      acceptTitle = isIncoming ? 'Ответить' : 'Отменить';
    }

    let callLabel = '';
    if (isInterception) {
      callLabel = 'Приглашение в разговор от сотрудника';
    } else {
      callLabel =
        type === Type.INCOMING ? 'Входящий звонок' : 'Исходящий звонок';
    }

    return (
      <StyledCallingState
        className={className}
        onSubmit={this.handleSubmit}
        $type={type}
      >
        <StyledContent>
          <CallingIcon width={37} />
          <StyledInfo>
            {fullName && <span>{fullName}</span>}
            {number && <span>{number}</span>}
            {!fullName && !number && <span>{callLabel}</span>}
          </StyledInfo>
          <StyledAccept disabled={isClicked}>{acceptTitle}</StyledAccept>
        </StyledContent>
        <AudioPlayer
          loop
          autoLoad
          volume={volume}
          playStatus={
            !isClicked && isIncoming ? AudioStatus.PLAYING : AudioStatus.STOPPED
          }
          url={INCOMING_SOUND}
        />
        <AudioPlayer
          loop
          autoLoad
          volume={volume}
          playStatus={
            !isClicked && !isIncoming
              ? AudioStatus.PLAYING
              : AudioStatus.STOPPED
          }
          url={OUTGOING_SOUND}
        />
      </StyledCallingState>
    );
  }
}

const StyledCallingState = styled.form<{ $type: ValueOf<typeof Type> }>`
  background-image: linear-gradient(to left, #00e04b, #00b0b6);
  height: 100%;
  width: 100%;

  ${({ $type }) =>
    $type === Type.OUTGOING &&
    `
    background-image: linear-gradient(to left, #faed61, #f7aa1b);
  `}
`;

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const StyledInfo = styled.div`
  color: #fff;
  margin-left: 15px;

  > span {
    display: block;
    font-size: 12px;
  }

  > span:first-child {
    font-size: 17px;
  }
`;

const StyledAccept = styled.button<{ disabled: boolean }>`
  background-color: #fff;
  border: none;
  border-radius: 30px;
  color: #17181a;
  cursor: pointer;
  font-size: 14px;
  line-height: 40px;
  padding: 0 43px;
  font-weight: bold;

  ${StyledInfo} + & {
    margin-left: 24px;
  }

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;
    opacity: 0.5;
  `}
`;

export { CallingState as default, Type };
